import { IAuctionConfigurations } from '../../../../../redux/reducers';
import { IConfigurationInfoSchema } from '../../../../../repositories/billing-tariffs/v1/publish-terms';
import { getServiceId, mapServiceTypes } from '../../../../../utils/publishTerms';

export function mapAuctionConfigurations(configurations?: IConfigurationInfoSchema[] | null): IAuctionConfigurations {
  if (!configurations) {
    return {};
  }

  return configurations.reduce((acc, configuration) => {
    const { serviceTypes, stepBet } = configuration;

    const services = mapServiceTypes(serviceTypes);
    const serviceId = getServiceId(services);

    acc[serviceId] = {
      serviceId,
      betStep: stepBet,
    };

    return acc;
  }, {} as IAuctionConfigurations);
}
